import { defineRoute } from '../defineRoute';

export const DEFAULT_RETURN_URL = '/';

export type LegacyLoginRouteParams = {
  returnUrl?: string | null;
};

export type LegacyLoginRouteParamsString = {
  returnUrl?: string;
};

export const LegacyLogin = defineRoute<
  LegacyLoginRouteParams,
  LegacyLoginRouteParamsString
>({
  pathname: '/user/login',
  nlPathname: '/gebruiker/inloggen',
  options: { isLandlordRoute: false, isPublic: true },
  routeParamsStringifier: routeParams => {
    return {
      returnUrl: routeParams.returnUrl ?? undefined,
    };
  },
  routeParamsParser: routeParamsString => {
    return {
      returnUrl: routeParamsString.returnUrl || DEFAULT_RETURN_URL,
    };
  },
});
